import { ChangeDetectorRef, AfterViewInit, Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckBoxModule, InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { UploadModule } from '@progress/kendo-angular-upload';
import { DateInputsModule, FormatSettings } from '@progress/kendo-angular-dateinputs';
import { FormsModule } from '@angular/forms';
import { GridService } from 'app/services/grid.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FileManagerComponent } from '../file-manager/file-manager.component';
import { DrakeFilePreviewComponent } from '../drake-file-preview/drake-file-preview.component';
import { TranslocoPipe } from '@ngneat/transloco';
import { EditorModule } from "@progress/kendo-angular-editor";
import { MapModule } from '@progress/kendo-angular-map';
import { TileUrlTemplateArgs } from "@progress/kendo-angular-map";
import { ListBoxModule, ListBoxToolbarConfig } from "@progress/kendo-angular-listbox";
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { DrakeMatrixComponent } from '../drake-matrix/drake-matrix.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { BrowserModule } from '@angular/platform-browser';
import { RecaptchaComponent } from 'ng-recaptcha';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { DrakeViewStandardComponent } from '../drake-view-standard/drake-view-standard.component';
import { DrakeViewKpiComponent } from '../drake-view-kpi/drake-view-kpi.component';
import drakeScopeGridRoutes from '../drake-scope-grid/drake-scope-grid.routes';
import { QuickAddService } from 'app/services/quick-add.service';
import { FuseAlertComponent } from '@fuse/components/alert';
import { FormService } from 'app/services/form.service';
import { tap } from 'rxjs';



@Component({
  selector: 'app-drake-quick-add',
  templateUrl: './drake-quick-add.component.html',
  styleUrls: ['./drake-quick-add.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    InputsModule,
    CheckBoxModule,
    DropDownsModule,
    UploadModule,
    DateInputsModule,
    FormsModule,
    MatDialogModule,
    MatIconModule,
    EditorModule,
    MapModule,
    ListBoxModule,
    TranslocoPipe,
    MonacoEditorModule,
    HttpClientModule,
    RecaptchaModule,
    TranslocoPipe,
    DrakeViewStandardComponent,
    DrakeViewKpiComponent,
    FuseAlertComponent
  ],
  providers: [TranslocoPipe]
})
export class DrakeQuickAddComponent implements AfterViewInit, OnChanges {


  @Input() public baseData: any;
  @Input() public parentId: string;
  @Input() public defaultValues: any;
  @Input() public childScope: any;
  @Input() public childScopeView: any;
  @Input() public pageData: any;
  @Input() readonly: boolean = false;
  @Input() linkedId: string = "#NEWID#";
  @Output() public valueChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() public standAlone: boolean = true;


  public quickAddBaseData: any = {};
  private scope: string;
  private timeout = null;

  public format: FormatSettings = {
    displayFormat: "dd/MM/yyyy",
    inputFormat: "dd/MM/yy",
  };

  constructor(private cdRef: ChangeDetectorRef,
    private gridService: GridService,
    private drakeShared: DrakeSharedService,
    public dialog: MatDialog,
    private http: HttpClient,
    private quickAddService: QuickAddService,
    private formService: FormService,
    private translocoPipe: TranslocoPipe
  ) {

  }

  ngAfterViewInit(): void {
    console.log("ecco baseData", this.baseData);
  }

  ngOnInit() {


  }

  onChange($event: any) {
    //throw new Error('Method not implemented.');

    if (!this.standAlone){
      this.baseData[this.childScope] = this.quickAddBaseData[this.childScope];
      
    }
    
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.defaultValues) {

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
      }


      this.timeout = setTimeout(() => {
        this.setDefaultValues();
      }, 1000);
    }

    if (changes.linkedId && this.linkedId && this.linkedId != '#NEWID#') {
      this.quickAddBaseData[this.childScope][this.linkedId]._id = this.linkedId;
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
      }
      this.gridService.getScopeData(this.childScope, "READ", { ViewCode: this.childScopeView.viewCode, Filter: JSON.stringify({ _id: this.linkedId }) }).subscribe((result) => {

        if (result.data.length > 0) {
          this.quickAddBaseData[this.childScope][this.linkedId] = { ...this.quickAddBaseData[this.childScope][this.linkedId], ...result.data[0] };
          if (!this.standAlone){

            this.baseData[this.childScope] = this.quickAddBaseData[this.childScope];
          }
          this.drakeShared.editableSubject.next(this.quickAddBaseData[this.childScope][this.linkedId]._editable);

        }
      })
    }
  }

  setDefaultValues() {
    if (this.defaultValues) {
      if (!this.quickAddBaseData[this.childScope])
        this.quickAddBaseData[this.childScope] = {};
      if (!this.quickAddBaseData[this.childScope][this.linkedId])
        this.quickAddBaseData[this.childScope][this.linkedId] = {}

      let localBaseData = this.quickAddBaseData[this.childScope][this.linkedId];
      const isAllNull = localBaseData && Object.values(localBaseData).every(value => value === null);
      if(isAllNull){
        Object.keys(localBaseData).forEach(function (index) {
          localBaseData[index] = null;
        });
        this.quickAddBaseData[this.childScope][this.linkedId] = { ...localBaseData, ...this.defaultValues };
      }
      console.log("quickAdd data: ", this.quickAddBaseData[this.childScope][this.linkedId]);
    }
  }

  quickAddSave() {
    var invalidFields = this.formService.applyValidation(this.quickAddBaseData[this.childScope][this.linkedId], this.childScope, this.pageData);
    if (invalidFields.length) {
      var notification = this.translocoPipe.transform("notification.error.quickadd.save");
      this.drakeShared.showTemporaryNotification(notification, 'error');
      return false;
    }

    this.gridService.saveScopeData(this.childScope, "UPSERT", this.quickAddBaseData[this.childScope][this.linkedId], false).subscribe((result: any) => {
      console.log("callresult", result);

      this.quickAddService.updateQuickAddData(this.childScope);

      if (this.linkedId == '#NEWID#')
        this.setDefaultValues();

      var notification = this.translocoPipe.transform("notification.success.quickadd.save");
      this.drakeShared.showTemporaryNotification(notification, 'success');

    },
      (err: any) => {
        console.log(err)
        var notification = this.translocoPipe.transform("notification.error.quickadd.save");
        this.drakeShared.showTemporaryNotification(notification, 'error');
      });

  }

}
